import { registerQuery } from 'data-fetching-client';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { getFullUrl } from 'hubspot-url-utils';
import getUserInfo from 'hub-http/userInfo';
import { getEarlyRequestResult } from '../utils/earlyRequest';
export const GET_COOKIE_AUTH = registerQuery({
  fieldName: 'cookieAuth',
  args: ['earlyRequestName'],
  fetcher({
    earlyRequestName
  }) {
    return getEarlyRequestResult(earlyRequestName, () => noAuthHttp.get(`${getFullUrl('app-api')}/cookie-echo/v1/user`));
  }
});
export const GET_USER_INFO = registerQuery({
  fieldName: 'userInfo',
  fetcher: getUserInfo
});